module.exports = __webpack_public_path__ + "static/media/pick11-cricketplayer.e9161138.png";